import { PopperOrigin } from "./Popper"

export type CommonPopperProps = {
  popperTitle?: string
  onClose: () => void
  onDelete?: () => void
  className?: string
  anchorEl: HTMLElement | null
  anchorOrigin?: PopperOrigin
  transformOrigin?: PopperOrigin
  lightMode?: boolean
  dataCy?: string
  confirmText?: string
}
